import { setErrorDialog, serverUrl, getheader} from "../../../store/api/CommonFunctions";

export function getPageFieldList(pageName) {
    return dispatch => {
        fetch(serverUrl + `api/AccountAPI/GetPageFieldList?pageName=${pageName}`, {
            method: "GET",
            cache: "default",
            headers: getheader()
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "PAGE_FIELD_LIST",
                    data: res
                });
            }).catch(e => {
                console.log("[PAGE_FIELD_LIST]", e)
                return dispatch({
                    type: "PAGE_FIELD_LIST",
                    data: null
                });
            });
    }
}
export function getUserList(name)
{
    return dispatch=>{
        dispatch({
            type:"GET_USER_LIST",
            data:"PENDING"
        });
        if(!name)
        {
            name = "";
        }
        fetch(serverUrl+"api/UserAPI/SearchUser?Name="+name,{
            headers:getheader(),
            method:"GET"
        }).then(res=>res.json())
        .then(res=>{
            if(res.Message)
            {
                res = null;
            }
            return dispatch({
                type:"GET_USER_LIST",
                data:res
            });
        })
    }
}
export function setUserPop(status){
    return dispatch=>{
       return dispatch({
            type:"USER_POP",
            data:status
        });
    }
}
export function setSelectedUserPop(status){
    return dispatch=>{
       return dispatch({
            type:"SELECTED_USER_POP",
            data:status
        });
    }
}
export function setReferDocPop(status){
    return dispatch=>{
       return dispatch({
            type:"REFERDOC_POP",
            data:status
        });
    }
}
export function referDocument(data, fn)
{
    return dispatch=>{
        fetch(serverUrl+"api/UserDashboardAPI/ReferDocument",{
            headers:getheader(),
            method:"POST",
            body:JSON.stringify(data),
            cache:"no-cache"
        }).then(res=>res.json())
        .then(res=>{
            if(res.Message)
            {
                setErrorDialog(dispatch, res.Message, "ارجاع به کاربر");
                return;
            }
            setErrorDialog(dispatch,"success","ارجاع به کاربر");
            if(fn)
            {
                fn();
            }
        })
    }
}